<template>
	<div @click="clearfilters">Clear All Filters</div>
</template>

<script>

export default {
	name: 'ClearfiltersButton',
	components: {
	},
	props: ["extraFunc"],
	methods:{
		clearfilters(){
			//copy object, otherwise it doesnt work because object hasn't changed
			let initialQuery = Object.assign({},this.$route.query);

			//clear local search
			delete initialQuery.search;
			//clear brand
			delete initialQuery.brand;
			//clear subcategory
			delete initialQuery.refine
			// //clear price filters
			delete initialQuery.priceLow
			delete initialQuery.priceHigh

			if (Object.keys(this.$route.query).length) {
				this.$router.push({query: initialQuery})

			}

			if(this.extraFunc){
				this.extraFunc();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
// sidebar styles are set in the sidebar.scss file in styles folder, changes will affect other sidebars

</style>